import StaffLoginForm from "@/components/Auth/StaffLoginForm";

export default function PartsLoginPage() {
    return (
        <StaffLoginForm
            title="Parts Login"
            subtitle="Sign in as Parts Clerk or Parts Manager"
            backgroundImage="/images/assets/dealership_parts_futuristic_1.png"
        />
    );
}
